import { style } from '@primeuix/styles/inputotp';
import BaseStyle from '@primevue/core/base/style';

var classes = {
  root: 'p-inputotp p-component',
  pcInputText: 'p-inputotp-input'
};
var InputOtpStyle = BaseStyle.extend({
  name: 'inputotp',
  style: style,
  classes: classes
});

export { InputOtpStyle as default };
//# sourceMappingURL=index.mjs.map
